module.exports = __webpack_public_path__ + "img/jbtyk03.1cc61f42.png";